import { Component } from '@verndale/core';
import { setTrackDataLayer, getCookie } from '../utils/index';
import Cookies from 'js-cookie';

class Checkout extends Component {
  setupDefaults() {
    this.dom = {
      cartItemSkus: this.$el.data().cartItemSkus,
      userId: this.$el.data().userId,
      redirectUrl: this.$el.data().redirectUrl
    };

    this.setCookie();
  }

  setCookie() {
    const ceraplusSkusCookie = getCookie('ceraplusSkus');
    let additionalProducts = false, removedProducts = false, accessoriesRemoved = false, onlyRemovedProducts = false;

    if (this.dom.userId && ceraplusSkusCookie) {
      const cartItemsSkus =
        this.dom.cartItemSkus.toString().indexOf(',') > -1
          ? this.dom.cartItemSkus.split(',')
          : [this.dom.cartItemSkus.toString()];
      const ceraplusSkus = ceraplusSkusCookie.split('%2C');

      for (let i = 0; i < cartItemsSkus.length; i++) {
        if (!ceraplusSkus.includes(cartItemsSkus[i])) {
          additionalProducts = true;
        }
      }

      const result = [];

      if (cartItemsSkus.length) {
        cartItemsSkus.forEach(item => {
          const notEqualItems = ceraplusSkus.map(sku => sku !== item && true);
          result.push(notEqualItems);
        });
      }

      const removeProductsCookie = getCookie('removedProducts');

      if (removeProductsCookie) {
        removedProducts = JSON.parse(removeProductsCookie);
        accessoriesRemoved = removedProducts.filter(sku => accessoriesArray.includes(sku.toString()));
        onlyRemovedProducts = removedProducts.filter(sku => !accessoriesArray.includes(sku.toString()));
      }
      const accessories = getCookie('ceraplusAccessories');
      const accessoriesArray = accessories ? accessories.split(',') : [];
      const accessoriesAdded = cartItemsSkus.filter(sku => accessoriesArray.includes(sku.toString()));

      const finalRemovedResult = result.flat().every(num => num === true);

      setTrackDataLayer({
        eventName: 'ceraplus_request_sample',
        custom: {
          cart_ID: this.dom.userId,
          products_list: ceraplusSkus.toString(),
          remove_products: finalRemovedResult,
          add_products: additionalProducts,
          products_added: cartItemsSkus.toString(),
          products_removed: onlyRemovedProducts.toString(),
          accessories: accessoriesAdded.length > 0,
          accessories_added: accessoriesAdded.toString(),
          accessories_removed: accessoriesRemoved.toString()
        }
      });


      if (Cookies.get('ceraplusAccessories')) {
        Cookies.remove('ceraplusAccessories', { path: '/' });
      }

      if (Cookies.get('removedProducts')) {
        Cookies.remove('removedProducts', { path: '/' });
      }

      if (Cookies.get('ceraplusSkus')) {
        Cookies.remove('ceraplusSkus', { path: '/' });
      }
    }

    if (this.dom.redirectUrl) {
      window.location.href = this.dom.redirectUrl;
    }
  }
}

export default Checkout;
